import { filterOptions } from '@/utils/query-base'

// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'fee_code': {
    title: '销售折扣编码',
    type: 'input',
  },
  'terminal_code': {
    title: '终端编码',
    type: 'input',
  },
  'terminal_name': {
    title: '终端名称',
    type: 'input',
  },
  'dealer_code': {
    title: '客户编码',
    type: 'dialog',
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    }
  },
  'dealer_name': {
    title: '客户名称',
    type: 'input',
  },
  'product_code': {
    title: '产品编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品编码'
    }
  },
  'state': {
    title: '核销状态',
    type: 'select',
    dictionary: 'A0075'
  },
}

export default {
  'fee_code': {
    title: '销售折扣编码',
    slot: true,
  },
  'terminal_code': {
    title: '终端编码',
    equation: all,
    dictionary: 'sale'
  },
  'terminal_name': {
    title: '终端名称',
  },
  'dealer_code': {
    title: '客户编码',
  },
  'dealer_name': {
    title: '客户名称',
    width: 224
  },
  'product_code': {
    title: '产品编码',
  },
  'product_name': {
    title: '产品描述',
    type: 'input',
  },
  'state_text': {
    title: '核销状态',
  },
  'total_amount': {
    title: '总金额',
  },
  'create_date': {
    title: '申请日期',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  },
  'audit_date': {
    title: '审核日期',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  },
  'act_name': {
    title: '活动名称',
    type: 'input',
  },
  'amount': {
    title: '活动金额',
  },
  'sheet_num': {
    title: '张数',
  },
}



// WEBPACK FOOTER //
// ./src/views/loan-manage/config/loanQuery.js